import * as React from 'react';
import { decodeHtmlEntities } from "../Helper/TextReplacer";
import { hasContent } from "./hasContent";
var H1Header = function (_a) {
  var text = _a.text;
  if (!text || !hasContent(text)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("h1", {
    className: "webmasterSeo"
  }, decodeHtmlEntities(text));
};
export default H1Header;